import React, { useEffect } from 'react';
import SlideOut, { SLIDE_OUT_VERTICAL_PADDING } from 'components/Slideout';
import usePopup from 'hooks/usePopup';
import Comments from 'components/Comments';
import { buildShowEntityAppContentTab } from 'navigation/appRoutes';
import useEntityParams from '../SelectedEntityProvider/useEntityParams';
import Button from 'kingpin/atoms/Button';

import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';
import { COMMENT_INPUT_ID } from '../../../components/Comments/CreateComment/CreateComment';

const TOP_HEIGHT = 64;
const PADDING_TOP = 24;
const SLIDEOUT_PADDING = SLIDE_OUT_VERTICAL_PADDING * 2;
const OFFSET = TOP_HEIGHT + PADDING_TOP + SLIDEOUT_PADDING;
const BODY_HEIGHT = `calc(100vh - ${OFFSET}px)`;

const TopBarDiv = styled.div`
  height: ${TOP_HEIGHT}px;
  border-bottom: 1px solid var(--color-grey-8);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const TopBar = ({ close }: { close: () => void }) => (
  <TopBarDiv>
    <Typography.Header type="H5">Notes</Typography.Header>
    <Button type="Tertiary" size="Small" onClick={close} icon={'cross'} />
  </TopBarDiv>
);

const CommentsButton = ({
  selectedEntity,
  app,
}: {
  selectedEntity: EntityDetails.SelectedEntity;
  app: EntityDetails.App;
}) => {
  const { tabType, value, tabId } = useEntityParams();
  const { isOpen, close, open } = usePopup();

  useEffect(() => {
    if (isOpen) {
      const commentInput = document.getElementById(COMMENT_INPUT_ID);
      if (commentInput) {
        commentInput.focus();
      }
    }
  }, [isOpen]);

  if (!tabType || !tabId) {
    return null;
  }

  return (
    <>
      <Button
        type="Tertiary"
        size="Small"
        onClick={open}
        icon="note-stack-add"
      />
      <SlideOut isOpen={isOpen} close={close}>
        <TopBar close={close} />
        <div
          style={{
            height: BODY_HEIGHT,
            overflowY: 'scroll',
            marginTop: PADDING_TOP,
          }}
        >
          {isOpen && (
            <Comments
              sendButtonText="Save"
              noScroll
              inputOnTop
              commentableId={selectedEntity.fieldValue}
              commentableType={selectedEntity.type.name}
              mentionedEmailBody={`mentioned you in on a ${selectedEntity.type.name} - ${selectedEntity.fieldValue}`}
              watcherEmailBody={`commented on a ${selectedEntity.type.name} - ${selectedEntity.fieldValue}`}
              emailLink={buildShowEntityAppContentTab({
                tabType,
                tabId,
                entityApp: app,
                value,
              })}
            />
          )}
        </div>
      </SlideOut>
    </>
  );
};

export default CommentsButton;
